export const chatConfig = {
    pageSize: 10,
} as const
